<div [ngClass]="classes()" class="user-header">
  <div class="user-header__banner"></div>
  <div class="user-header__content container">
    <div class="user-header__avatar-container">
      <avatar
        [loading]="userState.loading() || uploadingImage()"
        [name]="userFullName()"
        [src]="userState.user()?.usuario_imagen || null"
        shape="circle"
        [size]="avatarSize()"
        class="user-header__avatar" />
      <div
        (click)="onAvatarClick()"
        (keydown)="onAvatarKeydown($event)"
        role="button"
        tabindex="0"
        class="user-header__avatar-trigger">
        <gallery-outline class="user-header__avatar-edit" />
      </div>
      <input
        #avatarFileInput
        type="file"
        accept="image/jpeg,image/png,image/webp"
        (change)="onAvatarFileChange($event)"
        class="user-header__avatar-file-input" />
    </div>

    <div class="user-header__info">
      <div class="user-header__text">
        <h4 class="user-header__name">{{ userFullName() }}</h4>
        @if (userState.user()?.usuario_profesion; as ocupacion) {
          <div class="user-header__role">{{ ocupacion }}</div>
        }
      </div>
      @if (showEditProfile()) {
        <primary-button
          [routerLink]="routes.ACCOUNT_SETTINGS_PERSONAL_DATA"
          [icon]="EditTwoOutline"
          label="Editar perfil"
          variant="secondary"
          class="user-header__edit-button">
        </primary-button>
      }
    </div>
  </div>
</div>
